var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"filter-button",class:{ 'filter-button--active': _vm.active },on:{"click":_vm.toggleFilter}},[_c('span',{staticClass:"icon-filter"}),_vm._v("\n  "+_vm._s(_vm.$t('general.filters'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }